import { useQuery } from "@tanstack/react-query";
import { getCouponById } from "../../api/apiCoupons";

export const useGetCouponById = (id) => {
    const { data, isLoading, error, refetch } = useQuery({
        queryKey: ["coupon", id],
        queryFn: () => getCouponById(id),
        enabled: !!id, // Only run query if id exists
    });

    return {
        coupon: data?.data,
        isLoading,
        error,
        refetch,
    };
};
